export default __webpack_public_path__ + "static/media/logo.29f1d563.svg";